import { MutableRefObject, useLayoutEffect, useRef } from 'react';

// Route-bound instances ignore late responses, redirects and loading updates.
export function useRequestLifetime(): MutableRefObject<boolean> {
  const active = useRef(true);
  useLayoutEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);
  return active;
}
